import BillingsTaxiTaxiUpdateStatusRequest, {
  BillingsTaxiTaxiUpdateStatusRequestStatus,
} from "../../../../api/raily/billings/taxi-taxi/update-status/billings-taxi-taxi-update-status.request";
import BillingStatus from "../../../../types/billing-status";
import BillingsTaxiTaxiUpdateStatusParams from "./billings-taxi-taxi-update-status-params";

const createStatus = (
  status: BillingStatus,
): BillingsTaxiTaxiUpdateStatusRequestStatus => {
  switch (status) {
    case BillingStatus.ACCEPTED:
      return BillingsTaxiTaxiUpdateStatusRequestStatus.ACCEPTED;
    case BillingStatus.CREATED:
      return BillingsTaxiTaxiUpdateStatusRequestStatus.CREATED;
    case BillingStatus.REJECTED:
      return BillingsTaxiTaxiUpdateStatusRequestStatus.REJECTED;
    case BillingStatus.REOPENED:
      return BillingsTaxiTaxiUpdateStatusRequestStatus.REOPENED;
    case BillingStatus.REOPEN_REQUEST:
      return BillingsTaxiTaxiUpdateStatusRequestStatus.REOPEN_REQUEST;
  }
};

const create = (
  params: BillingsTaxiTaxiUpdateStatusParams,
): BillingsTaxiTaxiUpdateStatusRequest => {
  return {
    billingUuid: params.billingUuid,
    status: createStatus(params.status),
    comment: params.comment,
  };
};

const billingsTaxiTaxiUpdateStatusParamsFactory = {
  create,
};

export default billingsTaxiTaxiUpdateStatusParamsFactory;
